'use es6';

import { LAYOUT_MOVE_RENAME, LAYOUT_EDITOR_SESSION_SET_WIDGET_SELECTIONS, LAYOUT_EDITOR_SESSION_CLEAR_WIDGET_SELECTIONS, LAYOUT_EDITOR_SESSION_ADD_WIDGET_SELECTION, LAYOUT_EDITOR_SESSION_REMOVE_WIDGET_SELECTION, LAYOUT_EDITOR_SESSION_TOGGLE_WIDGET_SELECTION, LAYOUT_EDITOR_SESSION_SCROLL_TO_WIDGET_SELECTIONS, LAYOUT_WIDGET_CLONE, LAYOUT_WIDGET_SPLIT, LAYOUT_GROUPING_CREATE // LAYOUT_DND_MOVE_WIDGET_AND_CREATE_CELL,
// LAYOUT_DND_MOVE_WIDGET_WITHIN_ROW,
// LAYOUT_DND_MOVE_WIDGET_TO_NEW_ROW,
// LAYOUT_DND_MOVE_WIDGET_AND_CREATE_ROW,
// LAYOUT_DND_INSERT_SIDEBAR_WIDGET_IN_ROW,
// LAYOUT_DND_INSERT_SIDEBAR_WIDGET_AND_CREATE_CELL,
// LAYOUT_DND_MOVE_SIDEBAR_WIDGET_AND_CREATE_ROW,
, FINDER_FILE_RENAME, LAYOUT_EDITOR_SESSION_SET_EDITING_LANGUAGE, LAYOUT_LOCALIZATION_CHANGE_MASTER_LANGUAGE, LAYOUT_LOCALIZATION_DELETE_LANGUAGE } from 'DesignData/actions/ActionTypes';
import { findWhere } from 'underscore';
import { addWidgetSelection, clearWidgetSelections, setEditorMode } from 'DesignData/actions/LayoutEditorSession';
import { clearUndoHistory, stripCssClassDuplicates } from 'DesignData/actions/UnifiedLayouts';
import { flash } from 'DesignData/actions/Flash';
import { makeGetWidgetContextualData } from 'DesignData/selectors/layoutData';
import { getEditingLanguage } from 'DesignData/selectors/layoutEditorSession';
import { FOCUS_WIDGET_PROPERTIES_EDITOR } from 'DesignData/enums/FlashKeys';
import { LOCALIZATION, DEFAULT } from 'DesignData/enums/EditorModes';
const getWidgetContextualData = makeGetWidgetContextualData();
/*
 *
 */

export default (({
  dispatch,
  getState
}) => next => action => {
  const result = next(action);
  const state = getState();
  /*
   *
   * Strip duplicate CSS classes from prior selected widgets.
   *
   * This is the case when editing multiple widgets' css classes.
   * They are allowed to enter dupes in case one classname is also
   * the prefix of another.
   *
   */

  switch (result.type) {
    case LAYOUT_EDITOR_SESSION_SET_WIDGET_SELECTIONS:
    case LAYOUT_EDITOR_SESSION_CLEAR_WIDGET_SELECTIONS:
    case LAYOUT_EDITOR_SESSION_ADD_WIDGET_SELECTION:
    case LAYOUT_EDITOR_SESSION_REMOVE_WIDGET_SELECTION:
    case LAYOUT_EDITOR_SESSION_TOGGLE_WIDGET_SELECTION:
      {
        const {
          layoutId,
          prevSelectedWidgets
        } = result;
        const {
          order: widgetIds
        } = prevSelectedWidgets;
        dispatch(stripCssClassDuplicates(layoutId, widgetIds));
        break;
      }

    default:
      break;
  }
  /*
   *
   * Clear undo/redo history
   *
   */


  switch (result.type) {
    case LAYOUT_MOVE_RENAME:
      {
        const {
          layoutId
        } = result;
        dispatch(clearUndoHistory(layoutId));
        break;
      }

    case FINDER_FILE_RENAME:
      {
        const {
          file
        } = result;

        if (file) {
          dispatch(clearUndoHistory(file.id));
        }

        break;
      }

    default:
      break;
  }
  /*
   *
   * Flashes
   *
   */


  switch (result.type) {
    // Widget toggling only occurs via user input (clicks or tabbing).
    // When this occurs, send a flash to focus the widget properties editor.
    case LAYOUT_EDITOR_SESSION_ADD_WIDGET_SELECTION:
    case LAYOUT_EDITOR_SESSION_TOGGLE_WIDGET_SELECTION:
      {
        const {
          layoutId,
          widgetId,
          prevSelectedWidgets: {
            widgets
          }
        } = result;

        if (!widgets[widgetId]) {
          dispatch(flash(FOCUS_WIDGET_PROPERTIES_EDITOR, {
            layoutId,
            widgetId
          }));
        }

        break;
      }

    default:
      break;
  }
  /*
   *
   * Autoselect widgets
   *
   */


  switch (result.type) {
    case LAYOUT_WIDGET_CLONE:
      {
        const {
          layoutId,
          cloneWidgetId
        } = result;
        dispatch(addWidgetSelection(layoutId, cloneWidgetId));
        break;
      }

    case LAYOUT_WIDGET_SPLIT:
      {
        const {
          layoutId,
          newWidget
        } = result;
        dispatch(addWidgetSelection(layoutId, newWidget.id));
        break;
      }
    // case LAYOUT_DND_MOVE_WIDGET_AND_CREATE_CELL: {
    //   const { layoutId, newCell } = result;
    //   dispatch(addWidgetSelection(layoutId, newCell.id));
    //   break;
    // }
    // case LAYOUT_DND_MOVE_WIDGET_WITHIN_ROW: {
    //   const { layoutId, widgetId } = result;
    //   dispatch(addWidgetSelection(layoutId, widgetId));
    //   break;
    // }
    // case LAYOUT_DND_MOVE_WIDGET_TO_NEW_ROW: {
    //   const { layoutId, widgetId } = result;
    //   dispatch(addWidgetSelection(layoutId, widgetId));
    //   break;
    // }
    // case LAYOUT_DND_MOVE_WIDGET_AND_CREATE_ROW: {
    //   const { layoutId, sourceWidgetId } = result;
    //   dispatch(addWidgetSelection(layoutId, sourceWidgetId));
    //   break;
    // }
    // case LAYOUT_DND_INSERT_SIDEBAR_WIDGET_IN_ROW: {
    //   const { layoutId, widget } = result;
    //   dispatch(addWidgetSelection(layoutId, widget.id));
    //   break;
    // }
    // case LAYOUT_DND_INSERT_SIDEBAR_WIDGET_AND_CREATE_CELL: {
    //   const { layoutId, newCell } = result;
    //   dispatch(addWidgetSelection(layoutId, newCell.id));
    //   break;
    // }
    // case LAYOUT_DND_MOVE_SIDEBAR_WIDGET_AND_CREATE_ROW: {
    //   const { layoutId, widget } = result;
    //   dispatch(addWidgetSelection(layoutId, widget.id));
    //   break;
    // }

    case LAYOUT_GROUPING_CREATE:
      {
        const {
          layoutId,
          groupingMatrix
        } = result;
        dispatch(clearWidgetSelections(layoutId));
        /*
         * Find and select the newly created cell - only the cell that is the new parent
         * for the selected widgets.  Partially selected rows will create multiple new cells.
         *
         * Assertion: For this action to dispatch, the groupingMatrix must be valid.
         * As such these data structures and properties will be present.
         */

        const {
          groups
        } = groupingMatrix.rows[0];
        const widgetId = findWhere(groups, {
          isSelected: true
        }).widgets[0];
        const {
          parentId
        } = getWidgetContextualData(state, {
          layoutId,
          widgetId
        });
        dispatch(addWidgetSelection(layoutId, parentId));
        break;
      }

    /*
     * Editor mode triggers
     */

    case LAYOUT_EDITOR_SESSION_SET_EDITING_LANGUAGE:
      {
        const {
          langCode,
          layoutId
        } = result;
        const mode = langCode ? LOCALIZATION : DEFAULT;
        dispatch(setEditorMode(layoutId, mode));
        break;
      }

    case LAYOUT_LOCALIZATION_CHANGE_MASTER_LANGUAGE:
    case LAYOUT_LOCALIZATION_DELETE_LANGUAGE:
      {
        const {
          layoutId
        } = result;
        const editingLanguage = getEditingLanguage(state, {
          layoutId
        });
        const mode = editingLanguage ? LOCALIZATION : DEFAULT;

        if (editingLanguage) {
          dispatch(setEditorMode(layoutId, mode));
        }

        break;
      }

    default:
      break;
  }
  /**
   * Widget Selections
   * Widget Routing
   */


  switch (result.type) {
    case LAYOUT_EDITOR_SESSION_SET_WIDGET_SELECTIONS:
    case LAYOUT_EDITOR_SESSION_SCROLL_TO_WIDGET_SELECTIONS:
      {
        if (result.type === LAYOUT_EDITOR_SESSION_SET_WIDGET_SELECTIONS && result.scroll !== true) {
          break;
        }

        setTimeout(() => {
          const layoutEditorEl = document.querySelector('.layout-editor');

          if (!layoutEditorEl) {
            return;
          } // This will get the selected module that appears first in DOM order.


          const moduleEl = layoutEditorEl.querySelector('.is--widget-selected');

          if (moduleEl) {
            moduleEl.scrollIntoView();
          }
        }, 0);
        break;
      }

    default:
      break;
  }

  return result;
});